import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ElloDeliveryLogo from '../assets/svg/ElloDeliveryLogo.svg';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="80vh"
      padding={2}
    >
      <Box mb={4}>
        <img
          src={ElloDeliveryLogo}
          alt="Ello Delivery Logo"
          style={{
            width: '200px',
            height: 'auto',
          }}
        />
      </Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Página não encontrada
      </Typography>
      <Typography variant="body1" gutterBottom>
        A página que você está procurando não foi encontrada.
      </Typography>
    </Box>
  );
};

export default NotFound;
